import { BASE } from '@/utils/base'
import { NFPOST, NGET, NPOST } from '@/utils/net-work'

const baseUri = '/api'
const baseMain = BASE ? BASE : ''
// const baseMain = 'http://www.test.17zuoye.net'
// const baseMain = 'https://www.staging.17zuoye.net'

/**
 * 1.获取确认教材信息
 */
function getConfirmBooks(params: { subject: string; level?: number; term?: number }) {
  return NGET(baseMain + '/book/sortbook.vpage', params)
}

/**
 * 2.获取题目列表
 */
function questionList(params: any) {
  return NPOST(baseUri + '/question/list', params)
}

/**
 * 3.获取题目分数
 */
function questionScores(params: { subject_id: string | number; usage: number }) {
  return NGET(baseUri + '/question_cart/set_scores', params)
}

/**
 * 4.设置题目分数
 */
function setScores(params: any) {
  return NPOST(baseUri + '/question_cart/set_scores', params)
}

/**
 * 5.获取试卷确认信息
 */
function getTransEvaluation(params: { subject_id: number | string; usage: number }) {
  return NGET(baseUri + '/question_cart/trans_evaluation', params)
}

/**
 * 6.设置题目分数
 */
function postTransEvaluation(params: {
  subject_id: number | string
  usage: number
  book_id?: string | number
  use_type?: string
}) {
  return NPOST(baseUri + '/question_cart/trans_evaluation', params)
}

/**
 * 7.轮询paper_id
 */
function assessmentPaperGetPaperId(params: { task_id: number }) {
  return NGET(baseUri + '/paper/assessment_paper_get_paper_id/' + params.task_id, {})
}

/**
 * 8.试卷详情接口
 */
function assessmentPaperDetail(params: {
  subject_id: string | number
  assessment_paper_record_id: string | number
}) {
  return NGET(baseUri + '/paper/assessment_paper/detail', params)
}

/**
 * 9.试卷列表接口
 */
function assessmentPaperList(params: { subject_id: number | string; page: number }) {
  return NGET(baseUri + '/paper/assessment_paper/list', params)
}
/**
 * 10. 获取教材系列
 */
function getSeries(params: { subject_id: number }) {
  return NPOST(baseUri + '/common/get_series', params)
}
/**
 * 11. 获取书册
 */
function getBooks(params: any) {
  return NPOST(baseUri + '/common/get_children_book_catalog', params)
}
/**
 * 12. 获取必要信息
 */
function getBaseInfo(params: any) {
  return NGET(baseMain + '/newexam/teacher/apply/index.api', params)
}
/**
 * 13. 获取最新信息
 */
function getLatestJsonData(params: any) {
  return NGET(baseMain + '/teacher/newexam/latestjoindata.api', params)
}
/**
 * 14. 校验是否为教师
 */
function checkTeacher(params: any) {
  return NGET(baseMain + '/newexam/teacher/apply/checkTeacher.vpage', params)
}
/**
 * 15.
 */
function getDefaultbook(params: { subject?: string }) {
  return NGET(baseMain + '/newexam/teacher/apply/defaultbook.api', params)
}
/**
 * 16. 获取教材信息
 */
function getSortbook(params: { subject?: string; level?: number; term?: number }) {
  return NGET(baseMain + '/newexam/teacher/apply/sortbook.api', params)
}
/**
 * 17. 获取教材单元信息
 */
function getUnits(params: { bookId?: string }) {
  return NGET(baseMain + '/newexam/teacher/apply/unitlist.api', params)
}
/**
 * 18. 获取教材单元信息
 */
function getStaffInfo(params: { school_id?: string; ptu_id?: number | string }) {
  return NGET(baseUri + '/auth/service-staff-info', params)
}
/**
 * 19. 精品试卷列表
 */
function getCpList(params: {
  subject_id?: number
  use_type?: string
  book_catalog_id?: string
  main_question_types?: any
  num_start?: number
  num_end?: number
  page?: number
}) {
  return NPOST(baseUri + '/paper/cp-paper-list', params)
}
/**
 * 19. 我的试卷列表
 */
function myPaperList(params: {
  subject_id: number | string
  page: number
  keyword?: string
  sort_way?: string
}) {
  return NPOST(baseUri + '/paper/assessment_paper/list', params)
}
// 20
function getProgress(params) {
  return NFPOST(baseMain + '/newexam/teacher/apply/progress.api', params)
}
// 21
function getPublishEdit(params) {
  return NGET(baseUri + '/exam/edit', params)
}
// 22
function postPublishEdit(params) {
  return NPOST(baseUri + '/exam/edit', params)
}
// 23
function publishAssessment(params) {
  return NFPOST(baseMain + '/newexam/teacher/apply/save.api', params)
}
function getExamInfo(params) {
  return NFPOST(baseMain + '/newexam/teacher/apply/info.api', params)
}
// 24 获取 exam status
function getExamStatus(params) {
  return NPOST(baseUri + '/exam/status', params)
}
// 25 查询试卷详情
function paperDetail(params: any) {
  return NGET(baseUri + '/paper/detail', params)
}
// 26 查询上传试卷
function getUploadPaperList(params: { subjectId: string | number; page: number; keyword?: string; sort_way?: string }) {
  return NPOST(baseUri + '/exam/have_url_paper/list', params)
}
// 27 获取上传配置
function getOssToken() {
  return NPOST(baseUri + '/paper/aliyun_token', {})
}
// 28 检查md5
function checkMd5(params: { md5: string }) {
  return NPOST(baseUri + '/auth/check_md5', params)
}
// 29 是否为私海
function checkPrivate(params) {
  return NGET(baseMain + '/newexam/teacher/apply/isPrivateSchool.api', params)
}
// 30 班级默认教材
function defaultClazzBook(params: any) {
  return NGET(baseMain + '/paper/detail', params)
}
// 31 班级教材
function getClazzSortBook(params: any) {
  return NGET(baseMain + '/teacher/new/homework/sortbook.api', params)
}
// 32 获取单元
function getUnitList(params: any) {
  return NGET(baseMain + '/teacher/unit/test/unitlist.api', params)
}
// 33 获取班级列表
function getClazzList(params: any) {
  return NGET(baseMain + '/teacher/unit/test/clazzlist.api', params)
}
// 34 班级测评列表接口
function getExamList(params: any) {
  return NGET(baseMain + '/teacher/unit/test/report/exam/list.api', params)
}
// 35 班级精品卷库
function getClsList(params: any) {
  return NPOST(baseUri + '/paper/cp-paper-list-cls', params)
}
// 36 我的测评/班级测评/已发布删除
function unitTestDelete(params: any) {
  return NFPOST(baseMain + '/teacher/unit/test/delete.api', params)
}
// 37 我的测评/班级测评/已发布编辑调整
function adjustUnitTest(params: any) {
  return NGET(baseMain + '/teacher/unit/test/adjust/index.api', params)
}
// 38 我的测评/班级测评/已发布编辑调整确定
function adjustConfirm(params: any) {
  return NFPOST(baseMain + '/teacher/unit/test/adjust.api', params)
}
// 39 我的测评/班级测评/已发布编辑调整确定
function assignConfirm(params: any) {
  return NFPOST(baseMain + '/teacher/unit/test/assign.api', params)
}

// 40 我的测评/班级测评/精品卷库获取默认教材
function getClazzDefaultBook(params: any) {
  return NGET(baseMain + '/teacher/new/homework/clazz/book.api', params)
}

export {
  getConfirmBooks,
  questionList,
  questionScores,
  setScores,
  getTransEvaluation,
  postTransEvaluation,
  assessmentPaperGetPaperId,
  assessmentPaperDetail,
  assessmentPaperList,
  getSeries,
  getBooks,
  getBaseInfo,
  getLatestJsonData,
  checkTeacher,
  getDefaultbook,
  getSortbook,
  getUnits,
  getStaffInfo,
  getCpList,
  myPaperList,
  getProgress,
  getPublishEdit,
  postPublishEdit,
  publishAssessment,
  getExamInfo,
  getExamStatus,
  paperDetail,
  getUploadPaperList,
  getOssToken,
  checkMd5,
  checkPrivate,
  getClazzList,
  defaultClazzBook,
  getClazzSortBook,
  getUnitList,
  getExamList,
  getClsList,
  unitTestDelete,
  adjustUnitTest,
  adjustConfirm,
  assignConfirm,
  getClazzDefaultBook
}
